import {
  forwardRef,
  type InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
} from 'react'
import { Trans } from '@lingui/react/macro'

import { cn } from '@jotta/utils/css'

export type PasswordInputProps = { showPassword?: boolean } & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'checked'
>

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput({ value, showPassword = false, ...props }, ref) {
    const buttonRef = useRef<HTMLButtonElement>(null)
    const [isVisible, setIsVisible] = useState(showPassword)
    const [paddingRight, setPaddingRight] = useState(0)

    useEffect(() => {
      const offsetWidth = buttonRef.current?.offsetWidth
      if (offsetWidth) {
        setPaddingRight(offsetWidth + 12)
      }
    }, [buttonRef.current?.offsetWidth, isVisible])

    return (
      <div className={cn('relative', props.className)}>
        <input
          {...props}
          value={value}
          type={isVisible ? 'text' : 'password'}
          className="input w-full"
          ref={ref}
          style={{
            paddingRight,
          }}
        />
        {!!value && (
          <button
            type="button"
            role="switch"
            aria-checked={isVisible}
            ref={buttonRef}
            onClick={() => setIsVisible(currentValue => !currentValue)}
            className="absolute right-2 top-1/2 -translate-y-1/2"
          >
            {isVisible ? <Trans>Hide</Trans> : <Trans>Show</Trans>}
          </button>
        )}
      </div>
    )
  },
)
